import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/auth/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class PermissionGuard {
  constructor(private readonly authService: AuthenticationService, private readonly toastr: ToastrService) {}

  canActivate(next: ActivatedRouteSnapshot): boolean {
    if (next.data?.permission) {
      if (this.authService.can(next.data.permission)) {
        return true;
      }
      this.toastr.info('No tiene permisos para acceder a esta página');
      return false;
    }
    return true;
  }
}
